import { render, staticRenderFns } from "./MyAccountEdit.vue?vue&type=template&id=5aca2563&scoped=true"
import script from "./MyAccountEdit.vue?vue&type=script&lang=js"
export * from "./MyAccountEdit.vue?vue&type=script&lang=js"
import style0 from "./MyAccountEdit.vue?vue&type=style&index=0&id=5aca2563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca2563",
  null
  
)

export default component.exports